import { api, ApiError } from '@/lib/api';
import type { SourceCoverage } from '@waypoint/shared';

export interface CustomerSlice {
  customerExternalId: string;
  customerName: string;
  revenueCents: number;
  percent: number;
  rank: number;
}

export interface ConcentrationRiskResult {
  windowDays: number;
  /** Every figure below is null without a connected, synced accounting/payments source (`coverage`). */
  totalRevenueCents: number | null;
  customers: CustomerSlice[] | null;
  topShare: number | null;
  top3Share: number | null;
  top5Share: number | null;
  hhi: number | null;
  severity: 'low' | 'medium' | 'high' | 'critical' | null;
  narrative: string | null;
  source: 'qbo' | 'stripe' | 'none' | null;
  coverage?: SourceCoverage;
}

/** Returned when the accounting integration (QBO / Stripe) isn't connected yet. */
const NOT_CONNECTED: ConcentrationRiskResult = {
  windowDays: 90,
  totalRevenueCents: null,
  customers: null,
  topShare: null, top3Share: null, top5Share: null, hhi: null,
  severity: null,
  narrative: 'Connect QuickBooks or Stripe to track customer concentration.',
  source: 'none',
};

export async function getConcentrationRisk(): Promise<ConcentrationRiskResult> {
  try {
    return await api('/v1/concentration-risk');
  } catch (err) {
    if (err instanceof ApiError && err.status === 404) return NOT_CONNECTED;
    throw err;
  }
}
